export default __webpack_public_path__ + "8105ca49b09b216a60263d303412cef4.png";